import React from 'react'
import Box from '@mui/material/Box'
import { GRID_MIN_WIDTH } from 'core/theme.tokens'

interface HorizScrollBoxProps {
  children: React.ReactNode
  minWidth?: number
}

export const HorizScrollBox: React.FC<HorizScrollBoxProps> = ({
  children,
  minWidth = GRID_MIN_WIDTH,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <Box sx={{ minWidth, width: '100%' }}>{children}</Box>
    </Box>
  )
}
